import { useNavigate, useParams } from "react-router-dom";
import { investorPoolCompanies } from "./PoolSummary";
import { useState } from "react";

import countries from "../../constants/countries.json";
import { ChevronLeftIcon } from "../../components/Icons";

export default function InvestorDetails() {
  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();

  const company = investorPoolCompanies.find((c) => c.id === Number(id));

  const [activeTab, setActiveTab] = useState<
    "exportByCountry" | "exportByBuyers"
  >("exportByCountry");

  if (!company) {
    return <div className="card">Investor not found</div>;
  }

  return (
    <div className="card rounded-md space-y-4 p-6">
      {/* Back Button */}
      <div className="ml-[9%] mt-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 font-medium text-gray-600 hover:text-gray-900"
        >
          <ChevronLeftIcon className="size-5" />
          Back
        </button>
      </div>

      {/* Header */}
      <div className="ml-[10%] mt-6 space-y-3">
        {/* Name + Country */}
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-semibold text-gray-900">
            {company.name}
          </h1>

          <div className="flex items-center gap-1 rounded-md bg-gray-100 px-2 py-0.5">
            <img
              className="h-4 w-4"
              src={
                countries.find((el) => el.iso2 === company.countryFlag)?.flag
              }
              alt="flag"
            />
            <span className="text-xs text-gray-600">{company.countryFlag}</span>
          </div>
        </div>

        {/* Address */}
        <p className="max-w-3xl text-sm leading-relaxed text-gray-600">
          {company.address}
        </p>

        {/* Website */}
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <span className="font-medium">Website</span>
          <span className="text-gray-400">•</span>
          <a
            href={company.website}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {company.website.replace(/^https?:\/\//, "")}
          </a>
        </div>
      </div>

      {/* Screenshots */}
      <div className="mt-8 space-y-8 w-[80%] mx-auto">
        <h3 className="text-base font-medium text-gray-700">Shipments</h3>
        <img
          src={company.screenShots.barChat}
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />

        <h3 className="text-base font-medium text-gray-700">
          Export Country/Region
        </h3>
        <img src={company.screenShots.map} />

        <h3 className="text-base font-medium text-gray-700">Shipments</h3>
        <img src={company.screenShots.shipmentPercentage} />

        {/* Export Tabs */}
        <div className="space-y-3">
          <div className="flex gap-2">
            <button
              onClick={() => setActiveTab("exportByCountry")}
              className={`px-3 py-1 text-sm rounded-md border ${
                activeTab === "exportByCountry"
                  ? "bg-gray-900 text-white"
                  : "bg-white text-gray-700"
              }`}
            >
              Export by Country
            </button>

            <button
              onClick={() => setActiveTab("exportByBuyers")}
              className={`px-3 py-1 text-sm rounded-md border ${
                activeTab === "exportByBuyers"
                  ? "bg-gray-900 text-white"
                  : "bg-white text-gray-700"
              }`}
            >
              Export by Buyers
            </button>
          </div>

          <img
            src={
              activeTab === "exportByCountry"
                ? company.screenShots.exportByCountry
                : company.screenShots.exportByBuyers
            }
            className="transition-opacity duration-200"
          />
        </div>
      </div>
    </div>
  );
}
